import { render } from "./DeleteTestimonialDialog.vue?vue&type=template&id=332de92f"
import script from "./DeleteTestimonialDialog.vue?vue&type=script&lang=js"
export * from "./DeleteTestimonialDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__